export const EAppValorantRegions = {
  EU: "eu",
  NA: "na",
  AP: "ap",
  BR: "br",
  LATIN: "latin",
} as const;

export type AppValorantRegion =
  (typeof EAppValorantRegions)[keyof typeof EAppValorantRegions];

export const EAppLolRegions = {
  EUW: "euw",
  NA: "na",
  EUNE: "eune",
  OCE: "oce",
  BR: "br",
  RU: "ru",
  TR: "tr",
  LAN: "lan",
  LAS: "las",
  ME: "me",
} as const;

export type AppLolRegion = (typeof EAppLolRegions)[keyof typeof EAppLolRegions];

export const EAppRegions = {
  ...EAppValorantRegions,
  ...EAppLolRegions,
} as const;

export type AppRegion = (typeof EAppRegions)[keyof typeof EAppRegions];

export interface IAppRegionInfo {
  code: AppRegion;
  codeLabel: string;
  label: string;
  greyImage?: string;
  whiteImage?: string;
}
